<list-view #listViewComponent [liste]="liste" *ngIf="liste"></list-view>
